// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1OXIp","header__title":"Header_header__title__2LPqT","header__background":"Header_header__background__1jZKL"};